<template>
  <div>
    <h6 class="mt-2">مقدمه:</h6>
ما در "شارژ مستر" به حفظ حریم خصوصی کاربران اهمیت بسیاری می‌دهیم. این سیاست نامه حریم خصوصی به شما توضیح می‌دهد که چگونه اطلاعات شما جمع‌آوری، استفاده و محافظت می‌شود. لطفاً این سیاست نامه را به دقت مطالعه کنید تا درک کاملی از روند استفاده از اطلاعات شما داشته باشید.

    <h6 class="mt-2">اطلاعاتی که ما جمع‌آوری می‌کنیم:</h6>
    در "شارژ مستر"، ما فقط اطلاعاتی که برای ارائه خدمات مورد نیاز است جمع‌آوری می‌کنیم. این اطلاعات عبارتند از:

    1. شماره موبایل: برای ارسال اطلاعیه‌ها و اطلاعات مربوط به حساب کاربری شما.
    2. نام و نام خانوادگی: برای شناسایی شما در سامانه و ارتباطات مرتبط.
    3. آدرس: در صورتی که شما این اطلاعات را وارد کنید، برای ارتباطات مرتبط با آدرس شما مانند ارسال فاکتورها و اطلاعات مرتبط با مدیریت ساختمان استفاده می‌شود.

    <h6 class="mt-2">استفاده از اطلاعات:</h6>
    ما از اطلاعات شما فقط برای ارائه خدمات مربوط به "شارژ مستر" استفاده می‌کنیم. اطلاعات شما به هیچ شخص یا سازمانی فروخته یا ارسال نمی‌شود. ما این اطلاعات را برای هیچ هدف تبلیغاتی یا بازاریابی استفاده نخواهیم کرد.

    <h6 class="mt-2">محافظت از اطلاعات:</h6>
    ما تمام تدابیر امنیتی لازم را برای حفاظت از اطلاعات شما اتخاذ می‌کنیم. اطلاعات شما در محیط‌های امن نگهداری می‌شود و تنها افراد مجاز به دسترسی به این اطلاعات دسترسی خواهند داشت.

    <h6 class="mt-2">حقوق شما:</h6>
    شما حق دارید که درخواست حذف یا اصلاح اطلاعات خود را داشته باشید. همچنین، می‌توانید درخواست اطلاعاتی که ما درباره شما نگهداری می‌کنیم را داشته باشید.

    <h6 class="mt-2">تغییرات در سیاست نامه:</h6>
    ممکن است این سیاست نامه در آینده تغییر کند. در صورتی که تغییراتی در سیاست حریم خصوصی اعمال شود، شما از طریق روش‌های مناسب از این تغییرات مطلع خواهید شد.

    <h6 class="mt-2">تماس با ما:</h6>
    در صورت داشتن هرگونه سوال یا ابهام درباره این سیاست نامه یا حفاظت از حریم خصوصی، لطفاً با ما تماس بگیرید.

    با تشکر از انتخاب "شارژ مستر"، ما به حریم خصوصی شما احترام می‌گذاریم و اعتماد شما برای ما بسیار ارزشمند است.
  </div>
</template>

<script>
import { BCard, BCardText, BCol, BRow } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardText,
    BCol,
    BRow,
  },
}
</script>

<style>
</style>
